import { TableActionMenu, type TableActionItem } from '@/components/shared';
import type { OrganizationTransactionTypeFilter } from '../types';

const TRANSACTION_TYPE_OPTIONS: Array<{
  value: OrganizationTransactionTypeFilter;
  label: string;
}> = [
  { value: 'all', label: 'All transactions' },
  { value: 'purchase', label: 'Purchases' },
  { value: 'voucher', label: 'Vouchers' },
  { value: 'usage', label: 'Usage' },
  { value: 'onboarding', label: 'Onboarding' },
  { value: 'adjustment', label: 'Adjustments' },
];

export interface OrganizationTransactionsFiltersProps {
  transactionType: OrganizationTransactionTypeFilter;
  actions?: TableActionItem[];
  onTransactionTypeChange: (value: OrganizationTransactionTypeFilter) => void;
}

export function OrganizationTransactionsFilters({
  transactionType,
  actions = [],
  onTransactionTypeChange,
}: OrganizationTransactionsFiltersProps) {
  return (
    <div className="flex flex-wrap items-end gap-3 border-b border-neutral-200 bg-neutral-50 px-5 py-4">
      <label className="flex min-w-[220px] flex-col gap-1 text-small font-medium text-neutral-700">
        Transaction type
        <select
          value={transactionType}
          onChange={(event) =>
            onTransactionTypeChange(event.target.value as OrganizationTransactionTypeFilter)
          }
          className="h-10 rounded-lg border border-neutral-200 bg-white px-3 text-body text-neutral-900"
        >
          {TRANSACTION_TYPE_OPTIONS.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </label>

      {actions.length > 0 ? (
        <div className="ml-auto flex min-w-[2.5rem] justify-end">
          <TableActionMenu actions={actions} label="Transaction table actions" />
        </div>
      ) : null}
    </div>
  );
}
